<div class="app-layout">
  <!-- Header - tylko gdy nie jesteśmy na stronie logowania -->
  @if(!isLoginPage){
  <app-header class="app-header"></app-header>
  }

  <!-- Main content area -->
  <div class="app-main" [class.with-sidebar]="!isLoginPage">
    <!-- Sidebar - tylko gdy nie jesteśmy na stronie logowania -->
    <mat-sidenav-container class="example-container">
      <mat-sidenav #sidenav mode="side" [opened]="app.isSideNavOpen()">
        @if(!isLoginPage){
        <app-sidebar class="app-sidebar"></app-sidebar>
        }
      </mat-sidenav>

      <mat-sidenav-content>
        <!-- Page content -->
        <main class="app-content" [class.full-width]="isLoginPage">
          @if(breadcrumbs.length > 0) {
          <nav class="breadcrumb-container">
            <ol class="breadcrumb-list">
              @for (crumb of breadcrumbs; track crumb.url; let last = $last) {
              <li class="breadcrumb-item" [class.active]="last">
                @if (!last) {
                <a [routerLink]="crumb.url">{{ crumb.label }}</a>
                <span class="breadcrumb-separator">/</span>
                } @else {
                <span>{{ crumb.label }}</span>
                }
              </li>
              }
            </ol>
          </nav>
          }
          <router-outlet />
        </main>

      </mat-sidenav-content>
    </mat-sidenav-container>


  </div>
</div>